import "./404.scss";
import React from "react";

export const NotFound = () => (
  <div className="Page404">
    <span>404</span>
  </div>
);
